module.exports = "/images/icon_08.svg?eb049a7d1f58f6533cf5b4b03d2d870a";